<template>
  <div>
    <router-link to="/account" class="link--no-decoration">
      <Button icon="user" class="button--header" @click="close">Account</Button>
    </router-link>
    <Button icon="sign-out" class="button--header" @click="logout">Sign Out</Button>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Button from '../Buttons/Button'

export default {
  name: 'UserMenu',
  components: { Button },
  methods: {
    ...mapActions(
      {
        logout: 'auth/logout',
        close: 'localModal/close',
      },
    ),
  },
}
</script>
